module.exports = __webpack_public_path__ + "img/logo_full.c67d73e7.png";